import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import {
  CategoriasFiltrarDto,
  CategoriasFiltrarSchema,
} from "./Categorias.Dto";
import { useToast } from "src/componentes";
import { useEffect, useState } from "react";
import {
  CategoriaBuscarTodos,
  CategoriaFiltrar,
} from "src/services/Estoque.Service";
import { MapearErrosServidor } from "src/hook/Functions";

const CategoriasCode = () => {
  const [data, setData] = useState<CategoriasFiltrarDto[] | undefined>([]);
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
  } = useForm<CategoriasFiltrarDto>({
    resolver: yupResolver(CategoriasFiltrarSchema),
  });

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      setLoading(true);
      await CategoriaBuscarTodos()
        .then((response) => {
          if (response.data.success) {
            setData(response.data.data);
          }
        })
        .catch((error) => {
          console.log(error);
          showToast({
            message: "Ocorreu erro ao buscar dados",
            title: "Erro",
            variant: "Danger",
          });
          return undefined;
        })
        .finally(() => {
          setLoading(false);
        });
    };
    Load();
    return () => {
      controller.abort();
    };
  }, []);

  const onSubmit = async (data: CategoriasFiltrarDto, e: any) => {
    setLoading(true);
    try {
      const response = await CategoriaFiltrar(data);
      if (response.data.success) {
        const data = response.data.data;
        setData(data);
        if (data.length == 0) {
          showToast({
            message: "Não encontrado",
            title: "Info",
            variant: "Info",
          });
        }
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } catch (error) {
      setData(undefined);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    loading,
    register,
    handleSubmit,
    onSubmit,
    errors,
  };
};

export default CategoriasCode;
